import React, { Component } from 'react';
import Header from './Shared/Header';
import Breadcrumbs from "./Header/Breadcrumbs";
import ArticlePage from './Articles/ArticlePage';
import ArticleBox from './Articles/ArticleBox';
import ArticleBanner from 'Articles/ArticleBanner';
import ArticleReviewer from 'Articles/ArticleReviewer';
import BottonPushes from './Shared/BottonPushes';
import isBreadcrumb from './Shared/isBreadcrumb';
import detectBots from "./Shared/DetectBots";
import Teaser from "./Shared/Teaser";
import Expert from "./Experts/Expert";
import FaqListComponent from "./FAQList/FaqListComponent";
import shortid from "shortid";
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import ShareBox from 'Shared/ShareBox';
import DiscoverMore from 'ProductPageRestructure/DiscoverMoreTreatments';
import CustomersAlsoLiked from 'ProductPageRestructure/RelatedContent';

class InformationalPageContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teaserClass: null,
            isMobile: window.innerWidth < 768,
            isDesktop: window.innerWidth >= 1025
        }
        if (this.props.Model.Model.BlogItems) {
            this.props.Model.Model.Teasers = this.props.Model.Model.BlogItems;
        }
    }

    componentDidMount() {
        if(document.querySelector(".successStoriesIndex")) {
            this.setState({
                teaserClass: "success-stories"
            })
        } else if(document.querySelector(".hairstylesForFineHairIndex")) {
            this.setState({
                teaserClass: "teaser-tips"
            })
        } else {
            this.setState({
                teaserClass: "teaser-causes"
            })
        }
        window.addEventListener('resize', this.checkWindowWidth);
    }
    checkWindowWidth = () => {
        this.setState({
            "isMobile": window.innerWidth < 768,
            "isDesktop": window.innerWidth >= 1025
        })
    }
    toogleActiveAcordionTab = (evt) => {
        const className = "active";
        const element = evt.target;

        if (element) {
            const sibling = element.nextElementSibling;

            element.classList.toggle(className);

            if (sibling) {
                element.nextElementSibling.classList.toggle(className);
            }
        }
    };

    render() {
        let articleWithImageIndex = 0;

        return (
            <div>
                {this.props.Model.Model.Slider.length > 0 ? (
                    <Header
                        topHeader={this.props.Model.Model.Slider[0]}
                        newClassName={document.querySelector(".globalLeadershipIndex, .reviewsExpertsPage") ? "" : `vh-section ${detectBots() ? "bot" : "full-height"}`}
                        breadcrumbs={this.props.breadcrumbs}
                    />
                ) : (
                    <Breadcrumbs breadcrumbProps={isBreadcrumb(this.props.breadcrumbs)} />
                )}
                <div className="informational-section">
                    <div className="main">
                        {this.props.Model.Model.Title && this.props.Model.Model.Title.Value !== "" && (
                            <h1 className="page-title" dangerouslySetInnerHTML={{"__html": this.props.Model.Model.Title.Value}} />
                        )}
                        {this.props.Model.Model.Review && this.props.Model.Model.Review.ReviewerName !== "" && (
                            <ArticleReviewer {...this.props.Model.Model.Review} />
                        )}
                        {this.props.Model.Model.Articles ? (
                            <div className="informational-articles-section">
                                {this.props.Model.Model.Articles ? this.props.Model.Model.Articles.map((article) => {
                                    return <ArticlePage key={shortid.generate()} index={article.Image.Value.length > 0 ? articleWithImageIndex++ : null} article={article} />
                                }) : null}
                            </div>
                        ) : null}
                        {this.props.Model.Model.Teasers && this.props.Model.Model.Teasers.length > 0 ? (
                            <div>
                                {(this.props.Model.Model.Title && this.props.Model.Model.Title.Value !== "") ? (
                                    <section className="main-header">
                                        {/* {this.props.Model.Model.Title.Value !== "" ? (
                                            <h1 dangerouslySetInnerHTML={{"__html": this.props.Model.Model.Title.Value}} />
                                        ) : null} */}
                                        {this.props.Model.Model.SubTitle ? (
                                            <p className="big-text" dangerouslySetInnerHTML={{"__html": this.props.Model.Model.SubTitle.Value}} />
                                        ) : null}
                                    </section>
                                ): null}
                                <Teaser teaser={this.props.Model.Model.Teasers} teaserClass={this.state.teaserClass} />
                                {this.props.Model.Model.ButtonText.Value !== "" ? (
                                    <div className="center-content">
                                        <a href={this.props.Model.Model.ButtonUrl.Value} className="button inverse">{this.props.Model.Model.ButtonText.Value}</a>
                                    </div>
                                ): null}
                            </div>
                        ) : null}
                        {this.props.Model.Model.ExpertsList ? (
                            <div>
                                {this.props.Model.Model.ExpertsList.map((expert) => (
                                    <Expert {...expert} key={shortid.generate()} WatchVideoText={this.props.Model.Model.WatchVideoText} />
                                ))}
                            </div>
                        ) : null}
                        {this.props.Model.Model.DiscoverMoreTreatments && this.props.Model.Model.DiscoverMoreTreatments.length > 0 && (
                            <DiscoverMore {...this.props.Model.Model.DiscoverMoreTreatments[0]} isDesktop={this.state.isDesktop} />
                        )}
                        {this.props.Model.Model.RelatedContent && this.props.Model.Model.RelatedContent.length > 0 && (
                            <CustomersAlsoLiked
                                {...this.props.Model.Model.RelatedContent[0]}
                                isMobile={this.state.isMobile}
                            />
                        )}
                        <ShareBox
                            MetaPageTitle={this.props.Model.Model.MetaPageTitle}
                            MetaPageDescription={this.props.Model.Model.MetaPageDescription}
                            lang={this.props.lang}
                        />
                        {this.props.Model.Model.ArticleBanner && (
                            <ArticleBanner banner={this.props.Model.Model.ArticleBanner} />
                        )}
                    </div>

                    {this.props.Model.Model.ArticleBoxesTitle && this.props.Model.Model.ArticleBoxesTitle.Value !== "" ? (
                        <h2 className="informational-boxes-title">{this.props.Model.Model.ArticleBoxesTitle.Value}</h2>
                     ) : null}
                    <div className="main informational-boxes">
                        {this.props.Model.Model.ArticleBoxes ? this.props.Model.Model.ArticleBoxes.map((box) => {
                            return <ArticleBox key={shortid.generate()} box={box} />
                        }) : null}
                    </div>
                    {this.props.Model.Model.FaqList && this.props.Model.Model.FaqList.length > 0 ? (
                        <React.Fragment>
                            <h2 className="main informational-faq-title" dangerouslySetInnerHTML={{ "__html": this.props.Model.Model.FaqList[0].FaqText.Value }} />
                            <div className="main informational-faq">
                                {this.props.Model.Model.FaqList[0].FaqItems.map((faq) => {
                                    return <FaqListComponent toogleActiveAcordionTab={this.toogleActiveAcordionTab} key={shortid.generate()} faq={faq} />
                                })}
                            </div>
                        </React.Fragment>
                    ) : null}
                    {this.props.Model.Model.References && this.props.Model.Model.References.Value !== "" ? <div className="main informational-article-references" dangerouslySetInnerHTML={{ "__html": this.props.Model.Model.References.Value }}/> : null}
                </div>
                {this.props.Model.Model.BottomTiles.length > 0 && (
                    this.props.instagram && this.props.instagram.length > 0 ? (
                        <BottonPushes instagram={this.props.instagram} bottonPushes={this.props.Model.Model.BottomTiles} />
                    ) : (
                        this.props.Model.Model.SalonFinderTile.length > 0 ? (
                            <BottonPushes salonFinder={this.props.Model.Model} bottonPushes={this.props.Model.Model.BottomTiles} salonCountries={this.props.salonCountries} />
                        ) : (
                            <BottonPushes bottonPushes={this.props.Model.Model.BottomTiles} />
                        )
                    )
                )}
            </div>
        )
    }
}

export default InformationalPageContent;
